import React, { memo, useMemo } from 'react';

import { Radio as RadioAntd, RadioProps } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import { cn, insertObjectIf } from 'utils';

import './style.scss';

export interface IRadio extends RadioProps {
	label?: string;
	inputClassName?: string;
	containerClassName?: string;
	require?: boolean;
	disabled?: boolean;
	horizontal?: boolean;
	labelClassName?: string;
	options: DefaultOptionType[];
	hasServerError?: boolean;
}
const Radio: React.FC<IRadio> = ({
	label,
	containerClassName = '',
	inputClassName = '',
	require = false,
	disabled = false,
	horizontal = true,
	labelClassName,
	options,
	hasServerError = false,
	...rest
}) => {
	const _options = useMemo(() => {
		return options?.map((item) => ({
			...item,
			value: item?.value,
			label: item?.label,
		}));
	}, [options]);

	return (
		<div
			className={cn(
				'flex',
				horizontal ? 'flex-row items-center' : 'flex-col',
				containerClassName
			)}
		>
			{label && (
				<label
					className={cn(
						'text-[13px] font-medium text-font2',
						horizontal && 'min-w-[110px]',
						labelClassName
					)}
				>
					{label} {require && <span className="text-error">*</span>}
				</label>
			)}
			<RadioAntd.Group
				options={_options}
				className={cn(
					'w-full text-[13px]',
					inputClassName,
					!horizontal && 'mt-3'
				)}
				disabled={disabled}
				{...insertObjectIf(hasServerError, {
					className: 'ant-radio-error',
				})}
				{...rest}
			/>
		</div>
	);
};

export default memo(Radio);
